(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dam-review-wall"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('dam-review-wall')) return;

    class DamReviewWall extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (this.reviews) {
            this.querySelector('[data-fieldset]').disabled = false;
            this.renderSummary();
            this.render();
          } else if (!this.loading) {
            this.load();
          }
          return;
        }
        this.initialized = true;
        this.pageSize = 12;
        this.page = 1;
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.grid = this.querySelector('[data-grid]');
        this.status = this.querySelector('[data-status]');
        this.pagination = this.querySelector('[data-pagination]');
        this.search = this.querySelector('[data-search]');
        this.rating = this.querySelector('[data-rating]');
        this.sort = this.querySelector('[data-sort]');
        this.photos = this.querySelector('[data-photos]');
        this.resetButton = this.querySelector('[data-reset]');
        this.retry = this.querySelector('[data-retry]');
        this.dialog = this.querySelector('[data-dialog]');
        this.locale = document.documentElement.lang || 'en';
        try {
          this.numberFormat = new Intl.NumberFormat(this.locale);
          this.dateFormat = new Intl.DateTimeFormat(this.locale, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
        } catch {
          this.locale = 'en';
          this.numberFormat = new Intl.NumberFormat('en');
          this.dateFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
        }
        this.querySelector('[data-filters]').addEventListener('submit', (event) => event.preventDefault());
        this.search.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.updateFilters(), 160);
        });
        [this.rating, this.sort, this.photos].forEach((control) => control.addEventListener('change', () => this.updateFilters()));
        this.resetButton.addEventListener('click', () => {
          this.search.value = '';
          this.rating.value = 'all';
          this.sort.value = 'newest';
          this.photos.checked = false;
          this.updateFilters();
        });
        this.retry.addEventListener('click', () => this.load());
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-previous-photo]').addEventListener('click', () => this.movePhoto(-1));
        this.querySelector('[data-next-photo]').addEventListener('click', () => this.movePhoto(1));
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.movePhoto(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.photoTrigger?.focus());
        this.load();
      }

      label(key, values = {}) {
        return (this.labels[key] || key).replace(/\{(\w+)\}/g, (_, name) => String(values[name] ?? ''));
      }

      number(value) {
        return this.numberFormat.format(value);
      }

      node(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      }

      safeImage(value) {
        try {
          const url = new URL(value);
          const judgeCdn = url.hostname === 'review-images.judgeme.com';
          const judgeExport = url.hostname === 's3.amazonaws.com' && url.pathname.startsWith('/me.judge.review-images/');
          return url.protocol === 'https:' && (judgeCdn || judgeExport) && !url.username && !url.password ? url.href : null;
        } catch {
          return null;
        }
      }

      async loadI18n() {
        if (!this.dataset.i18nSource) return null;
        try {
          const source = new URL(this.dataset.i18nSource, window.location.href);
          const shopifyCdn = source.hostname === 'cdn.shopify.com' && source.pathname.startsWith('/s/files/');
          const storeCdn = [window.location.hostname, this.dataset.shopDomain, this.dataset.storeDomain].includes(source.hostname) && source.pathname.startsWith('/cdn/shop/files/');
          if (source.protocol !== 'https:' || source.username || source.password || (!shopifyCdn && !storeCdn)) return null;
          const response = await fetch(source.href, { credentials: 'omit' });
          if (!response.ok) return null;
          const data = await response.json();
          if (data.schemaVersion !== 1 || data.shopDomain !== this.dataset.shopDomain || data.locale !== this.dataset.locale) return null;
          return data;
        } catch {
          return null;
        }
      }

      async load() {
        if (this.loading) return;
        this.loading = true;
        this.retry.hidden = true;
        this.status.textContent = this.label('loading');
        this.grid.setAttribute('aria-busy', 'true');
        try {
          const source = new URL(this.dataset.source, window.location.href);
          const shopifyCdn = source.hostname === 'cdn.shopify.com' && source.pathname.startsWith('/s/files/');
          const storeCdn = [window.location.hostname, this.dataset.shopDomain, this.dataset.storeDomain].includes(source.hostname) && (source.pathname.startsWith('/cdn/shop/files/') || /^\/cdn\/shop\/t\/[0-9]+\/assets\/dam-review-presentation-20261007\.json$/.test(source.pathname));
          if (source.protocol !== 'https:' || source.username || source.password || (!shopifyCdn && !storeCdn)) throw new Error('Invalid data host');
          const response = await fetch(source.href, { credentials: 'omit' });
          if (!response.ok) throw new Error('Review data unavailable');
          const data = await response.json();
          if (data.schemaVersion !== 1 || data.shopDomain !== this.dataset.shopDomain || !Array.isArray(data.reviews) || !data.products) throw new Error('Wrong review data');
          const i18n = await this.loadI18n();
          const ids = new Set();
          this.products = data.products;
          this.reviews = data.reviews.map((review) => {
            if (!review.id || ids.has(review.id) || !Number.isInteger(review.rating) || review.rating < 1 || review.rating > 5) throw new Error('Invalid review record');
            ids.add(review.id);
            const localizedReview = i18n?.reviews?.[review.id] || {};
            const localizedProduct = i18n?.products?.[review.productId] || {};
            const product = {
              ...(this.products[review.productId] || {}),
              ...(localizedProduct.title ? { title: localizedProduct.title } : {})
            };
            const images = (review.images || []).map((image) => ({ src: this.safeImage(image.src), thumb: this.safeImage(image.thumb) })).filter((image) => image.src && image.thumb);
            const title = localizedReview.title ?? review.title;
            const body = localizedReview.body ?? review.body;
            return {
              ...review,
              title,
              body,
              product,
              images,
              timestamp: Date.parse(review.createdAt) || 0,
              searchable: [title, body, product.title].join(' ').toLocaleLowerCase(this.locale)
            };
          });
          if (!this.isConnected) return;
          this.querySelector('[data-fieldset]').disabled = false;
          this.renderSummary();
          this.render();
        } catch {
          this.status.textContent = this.label('load_error');
          this.retry.hidden = false;
        } finally {
          this.loading = false;
          this.grid.setAttribute('aria-busy', 'false');
        }
      }

      renderSummary() {
        const count = this.reviews.length;
        const average = count ? this.reviews.reduce((total, review) => total + review.rating, 0) / count : 0;
        const formatted = average.toLocaleString(this.locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        const summary = this.querySelector('[data-summary]');
        summary.hidden = count === 0;
        summary.setAttribute('aria-label', this.label('summary', { rating: formatted, count: this.number(count) }));
        this.querySelector('[data-average]').textContent = formatted;
        this.querySelector('[data-summary-stars]').style.setProperty('--review-fill', `${average / 5 * 100}%`);
        this.querySelector('[data-total]').textContent = this.label('total_reviews', { count: this.number(count) });
        this.querySelector('[data-photo-count]').textContent = this.label('photo_reviews', { count: this.number(this.reviews.filter((review) => review.images.length).length) });
      }

      updateFilters() {
        if (!this.reviews) return;
        this.page = 1;
        this.render();
      }

      render() {
        const query = this.search.value.trim().toLocaleLowerCase(this.locale);
        const rating = this.rating.value;
        const filtered = this.reviews.filter((review) => (!query || review.searchable.includes(query)) && (rating === 'all' || review.rating === Number(rating)) && (!this.photos.checked || review.images.length));
        filtered.sort((a, b) => {
          const photoOrder = Number(Boolean(b.images.length)) - Number(Boolean(a.images.length));
          if (photoOrder) return photoOrder;
          const ratingOrder = this.sort.value === 'highest' ? b.rating - a.rating : this.sort.value === 'lowest' ? a.rating - b.rating : 0;
          return ratingOrder || b.timestamp - a.timestamp || b.id.localeCompare(a.id);
        });
        const pages = Math.max(1, Math.ceil(filtered.length / this.pageSize));
        this.page = Math.min(this.page, pages);
        const start = (this.page - 1) * this.pageSize;
        this.grid.replaceChildren(...filtered.slice(start, start + this.pageSize).map((review) => this.card(review)));
        this.status.textContent = filtered.length ? this.label('showing', { start: this.number(start + 1), end: this.number(Math.min(start + this.pageSize, filtered.length)), count: this.number(filtered.length) }) : this.label('no_results');
        this.resetButton.hidden = !query && rating === 'all' && !this.photos.checked && this.sort.value === 'newest';
        this.pagination.replaceChildren();
        if (pages <= 1) return;
        const go = (page) => {
          this.page = page;
          this.render();
          this.status.focus({ preventScroll: true });
          this.status.scrollIntoView({ block: 'start', behavior: 'auto' });
        };
        const button = (text, page, disabled = false) => {
          const item = this.node('button', 'dam-review-wall__page-button', text);
          item.type = 'button';
          item.disabled = disabled;
          item.addEventListener('click', () => go(page));
          return item;
        };
        this.pagination.append(button(this.label('previous'), this.page - 1, this.page === 1));
        const pageNumbers = [...new Set([1, pages, this.page - 1, this.page, this.page + 1].filter((page) => page >= 1 && page <= pages))].sort((a, b) => a - b);
        let previousPage = 0;
        pageNumbers.forEach((page) => {
          if (previousPage && page - previousPage > 1) this.pagination.append(this.node('span', 'dam-review-wall__page-gap', '…'));
          const item = button(this.number(page), page);
          item.setAttribute('aria-label', this.label('page', { page: this.number(page) }));
          if (page === this.page) item.setAttribute('aria-current', 'page');
          this.pagination.append(item);
          previousPage = page;
        });
        this.pagination.append(button(this.label('next'), this.page + 1, this.page === pages));
      }

      card(review) {
        const card = this.node('article', 'dam-review-wall__card');
        card.dataset.reviewId = review.id;
        if (review.images.length) {
          const media = this.node('button', 'dam-review-wall__media');
          media.type = 'button';
          const photo = this.node('img');
          photo.src = review.images[0].src;
          photo.alt = this.label('customer_photo', { product: review.product.title || '' });
          photo.loading = 'lazy';
          photo.decoding = 'async';
          photo.width = 720;
          photo.height = 540;
          photo.addEventListener('error', () => media.replaceChildren(this.node('span', '', this.label('photo_unavailable'))));
          media.append(photo);
          media.addEventListener('click', () => this.openPhoto(review, 0, media));
          card.append(media);
          if (review.images.length > 1) {
            const thumbnails = this.node('div', 'dam-review-wall__thumbnails');
            review.images.forEach((image, index) => {
              const thumb = this.node('button');
              thumb.type = 'button';
              thumb.setAttribute('aria-label', this.label('image_count', { index: index + 1, count: review.images.length }));
              const picture = this.node('img');
              picture.src = image.thumb;
              picture.alt = '';
              picture.loading = 'lazy';
              picture.width = 48;
              picture.height = 48;
              thumb.append(picture);
              thumb.addEventListener('click', () => this.openPhoto(review, index, thumb));
              thumbnails.append(thumb);
            });
            card.append(thumbnails);
          }
        }
        const content = this.node('div', 'dam-review-wall__card-content');
        const top = this.node('div', 'dam-review-wall__card-top');
        const stars = this.node('span', 'dam-review-wall__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `${review.rating} / 5`);
        top.append(stars);
        if (review.timestamp) {
          const date = this.node('time', '', this.dateFormat.format(new Date(review.timestamp)));
          date.dateTime = review.createdAt;
          top.append(date);
        }
        content.append(top, this.node('p', 'dam-review-wall__name', review.name && review.name !== 'Anonymous' ? review.name : this.label('anonymous')));
        const title = String(review.title || '').trim();
        if (title && title.toLowerCase() !== (review.product.handle || '').toLowerCase()) content.append(this.node('h2', 'dam-review-wall__review-title', title));
        const body = String(review.body || '').trim();
        if (body) {
          const paragraph = this.node('p', 'dam-review-wall__body', body);
          content.append(paragraph);
          if (body.length > 180 || body.split('\n').length > 3) {
            paragraph.classList.add('dam-review-wall__body--short');
            const more = this.node('button', 'dam-review-wall__text-button', this.label('read_more'));
            more.type = 'button';
            more.setAttribute('aria-expanded', 'false');
            more.addEventListener('click', () => {
              const expanded = more.getAttribute('aria-expanded') !== 'true';
              more.setAttribute('aria-expanded', String(expanded));
              paragraph.classList.toggle('dam-review-wall__body--short', !expanded);
              more.textContent = this.label(expanded ? 'read_less' : 'read_more');
            });
            content.append(more);
          }
        }
        const shop = this.shopBlock(review);
        if (shop) content.append(shop);
        card.append(content);
        return card;
      }

      productHref(review) {
        if (!review.product.handle || !/^[a-z0-9][a-z0-9-]*$/i.test(review.product.handle)) return '';
        return `${this.dataset.root.replace(/\/$/, '')}/products/${encodeURIComponent(review.product.handle)}`;
      }

      shopBlock(review) {
        const href = this.productHref(review);
        if (!href && !review.product.title) return null;
        const block = this.node('div', 'dam-review-wall__shop');
        if (review.product.title) block.append(this.node('p', 'dam-review-wall__product-name', review.product.title));
        if (href) {
          const link = this.node('a', 'dam-review-wall__shop-link', this.label('shop_this'));
          link.href = href;
          block.append(link);
        }
        return block;
      }

      openPhoto(review, index, trigger) {
        this.photoReview = review;
        this.photoIndex = index;
        this.photoTrigger = trigger;
        this.renderPhoto();
        if (!this.dialog.open) this.dialog.showModal();
      }

      movePhoto(delta) {
        if (!this.photoReview) return;
        this.photoIndex = Math.max(0, Math.min(this.photoReview.images.length - 1, this.photoIndex + delta));
        this.renderPhoto();
      }

      renderPhoto() {
        const review = this.photoReview;
        const image = this.querySelector('[data-dialog-image]');
        const many = review.images.length > 1;
        image.src = review.images[this.photoIndex].src;
        image.alt = this.label('customer_photo', { product: review.product.title || '' });
        this.querySelector('[data-previous-photo]').hidden = !many;
        this.querySelector('[data-next-photo]').hidden = !many;
        this.querySelector('[data-previous-photo]').disabled = this.photoIndex === 0;
        this.querySelector('[data-next-photo]').disabled = this.photoIndex === review.images.length - 1;
        this.querySelector('[data-dialog-name]').textContent = review.name && review.name !== 'Anonymous' ? review.name : this.label('anonymous');
        const date = this.querySelector('[data-dialog-date]');
        if (review.timestamp) {
          date.hidden = false;
          date.dateTime = review.createdAt;
          date.textContent = this.dateFormat.format(new Date(review.timestamp));
        } else {
          date.hidden = true;
        }
        const stars = this.querySelector('[data-dialog-stars]');
        stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
        stars.setAttribute('aria-label', `${review.rating} / 5`);
        const titleText = String(review.title || '').trim();
        const title = this.querySelector('[data-dialog-title]');
        title.hidden = !titleText || titleText.toLowerCase() === (review.product.handle || '').toLowerCase();
        title.textContent = titleText;
        const bodyText = String(review.body || '').trim();
        const body = this.querySelector('[data-dialog-body]');
        body.hidden = !bodyText;
        body.textContent = bodyText;
        const productName = this.querySelector('[data-dialog-product-name]');
        productName.hidden = !review.product.title;
        productName.textContent = review.product.title || '';
        const shop = this.querySelector('[data-dialog-product]');
        const href = this.productHref(review);
        shop.hidden = !href;
        shop.textContent = this.label('shop_this');
        if (href) shop.href = href;
        const thumbs = this.querySelector('[data-dialog-thumbs]');
        thumbs.hidden = !many;
        thumbs.replaceChildren();
        if (!many) return;
        review.images.forEach((item, index) => {
          const thumb = this.node('button');
          thumb.type = 'button';
          thumb.setAttribute('aria-label', this.label('image_count', { index: index + 1, count: review.images.length }));
          if (index === this.photoIndex) thumb.setAttribute('aria-current', 'true');
          const picture = this.node('img');
          picture.src = item.thumb;
          picture.alt = '';
          thumb.append(picture);
          thumb.addEventListener('click', () => {
            this.photoIndex = index;
            this.renderPhoto();
          });
          thumbs.append(thumb);
        });
      }
    }

    customElements.define('dam-review-wall', DamReviewWall);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pbn-custom-guidance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('slideshow:select', event => {
    const gallery = event.target.closest?.('media-gallery');
    if (!gallery?.closest('.product-information')?.querySelector('.dam-custom-guidance')) return;
    const slides = [...gallery.querySelectorAll('slideshow-slide')];
    const index = slides.indexOf(event.detail?.slide);
    const count = gallery.querySelector('[data-custom-gallery-count]');
    if (count && index >= 0) count.textContent = (index + 1) + ' / ' + slides.length;
    gallery.querySelectorAll('deferred-media').forEach(media => {
      if (media.closest('slideshow-slide') !== event.detail?.slide) media.pauseMedia?.();
    });
    gallery.querySelectorAll('video').forEach(video => {
      if (video.closest('slideshow-slide') !== event.detail?.slide) video.pause();
    });
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    document.querySelectorAll('.product-information:has(.dam-custom-guidance) deferred-media').forEach(media => media.pauseMedia?.());
    document.querySelectorAll('.product-information:has(.dam-custom-guidance) video').forEach(video => video.pause());
  });
  window.addEventListener('dialog:close', () => {
    document.querySelectorAll('.product-information:has(.dam-custom-guidance) video').forEach(video => video.pause());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pbn-custom-size-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('diyam-size-preview')) {
    customElements.define('diyam-size-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-size-open]');
        this.trigger.addEventListener('click', () => this.open());
        this.querySelector('[data-size-close]').addEventListener('click', () => this.close());
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); });
        this.dialog.addEventListener('close', () => {
          this.frame?.remove();
          this.frame = null;
          if (this.trigger.isConnected) this.trigger.focus({preventScroll:true});
        });
      }
      open() {
        if (this.dialog.open) return;
        const selected = this.closest('[data-pbn-custom-experience], .product-details')?.querySelector('[data-pbn-custom-size]:checked, variant-picker [data-fieldset-index="0"] input:checked');
        const dimensions = selected?.value.match(/(40|50|60)\s*[×x]\s*(50|60|80)/i);
        const key = dimensions ? `${dimensions[1]}x${dimensions[2]}` : '50x60';
        const availableSizes = Array.from(this.querySelector('template').content.querySelectorAll('[data-size]'), button => button.dataset.size);
        const size = availableSizes.includes(key) ? key : availableSizes.includes('50x60') ? '50x60' : availableSizes[0];
        if (!size) return;
        const locale = (this.dataset.locale || 'en').replace(/[^a-zA-Z-]/g,'');
        const markup = this.querySelector('template').innerHTML.replace('data-initial-size=""',`data-initial-size="${size}"`);
        this.frame = document.createElement('iframe');
        this.frame.title = this.querySelector('h2').textContent;
        this.frame.srcdoc = `<!doctype html><html lang="${locale}"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"></head><body>${markup}</body></html>`;
        this.querySelector('[data-size-frame]').append(this.frame);
        this.dialog.showModal();
      }
      close() { this.dialog.close(); }
      disconnectedCallback() { this.frame?.remove(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
